/*eslint-disable*/
import React from 'react';
import "../../../assets/css/common/AllCss.css";
import "../../../assets/css/common/Swiper.css";
import Swiper from "../../../assets/js/libs/swiper.min.js";	//轮播
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import {lazyImg, setScrollTop} from '../../../assets/js/utils/util.js';		//图片懒加载	
import SearchComponent from '../../../components/search/search.js';
import { Toast } from 'antd-mobile';


export default class keComponent extends React.Component{
	constructor(){
		super();
		this.state = {
			aSwitch : [],
			publicCourses: null,
			zhibo: null,
			recom: [],
			Screen: false,
			phone: localStorage['phone']!== undefined?localStorage['phone']:'',
			BiaoQianJson: null,
			BiaoQianJson2: null,
			bgFlag: false
		};
		this.Screen = true;
		this.searchStyle = {display:"none"};
	}
    componentDidMount(){
    	setScrollTop(global.scrollTop.index);
        this.getSwitch();
        window.addEventListener("scroll", this.isScren.bind(this),false);
    }
    componentWillUnmount(){
    	//界面离开的时候
		this.Screen = false;
		window.removeEventListener("scroll", this.isScren.bind(this));
		this.setState = (state, callback)=>{
			return;
		}
	}
    isScren(){
    	if(this.Screen){
    		let isScreen = document.documentElement.scrollTop || document.body.scrollTop;
    		global.scrollTop.index = isScreen;
	    	if(isScreen>=100){
	    		this.setState({
	    			Screen : true
	    		});
	    	}else{
	    		this.setState({
	    			Screen : false
	    		});
	    	}
    	}
    }
    getSwitch(){
    	//轮播图
    	request(config.baseUrl+'api/Study/S002', "post").then(res=>{
            //console.log(res)
            if(res.code == 0){
            	this.setState({
					aSwitch: res.data.adPics
            	}, ()=>{
    				lazyImg();
    				new Swiper(this.refs['swiper-container'], {
                        autoplay: {
				        	delay: 3000,
				        	disableOnInteraction: false
				      	},
				      	pagination: {
					        el: '.swiper-pagination',
					    }
                    })
    			})
            	this.setState({
					publicCourses: res.data.publicCourses
            	}, ()=>{
    				lazyImg();
    			})
            }
        });
        //标签及标签对应课程
        let Arr = localStorage['Arr'] !==undefined ?JSON.parse(localStorage['Arr']):null;
        if(Arr){
        	Arr.forEach(item => {
        		item.checked = false;
        	})
        	this.setState({
            	BiaoQianJson: Arr,
            	BiaoQianJson2: Arr
            })
        }else{
        	this.getKeChen();
        }
        //消息数
//      request(config.baseUrl+'api/Study/S009', "post").then(res=>{
//          //console.log(res)
//          if(res.code == 0){
//          	this.setState({
//					zhibo: res.data
//          	}, ()=>{
//  				lazyImg();
//  			})
//          }
//      });
    }
    getKeChen(){
    	//标签及标签对应课程
    	request(config.baseUrl+'api/Study/S019', "post").then(res=>{
            let Arr = [];
            if(res.code == 0 && res.data.length>0){
            	res.data.forEach((item,index) => {
            		Arr.push({});
            		request(config.baseUrl+'api/Study/S006', "post", {tagId: item.id}).then(res2=>{
			            res2.data.forEach(item2 => {
			            	item2.checked = false;
			            	if(item2.outlines.length>0){
			            		Arr[index] = item2;
			            	}
			            })
			            this.setState({
			            	BiaoQianJson: Arr,
			            	BiaoQianJson2: Arr
			            })
			        });
            	})
            }
        });
    }
    LeftIcon(path){
    	if(path == '/NavCourse'){
    		this.setState({
    			bgFlag: true
    		})

    	}else{
    		this.props.history.push(path);
    	}
    }
    alertBtn(indx){
    	let BiaoQianJson = this.state.BiaoQianJson;
		let Arr = [];
		
    	if(indx == 1){
    		BiaoQianJson.forEach(item => {
    			if(item.checked){
    				Arr.push(item);
    			}
    		})
    		this.setState({
				BiaoQianJson2: Arr
			})
    	}else if(indx == 2){
    		BiaoQianJson.forEach(item => {
    			item.checked = false;
    		})
    		this.setState({
				BiaoQianJson2: BiaoQianJson,
				BiaoQianJson: BiaoQianJson
			})
    	}
    	this.setState({
			bgFlag: false
		})
    }
    searchClick(display){
    	this.setState(
    		this.searchStyle = display
    	)
    }
    pushPage(){
    	this.props.history.push('/notfind');
    }
    tagNameClick(index){
    	let BiaoQianJson = this.state.BiaoQianJson;
    	BiaoQianJson[index].checked = !BiaoQianJson[index].checked;
    	this.setState({
			BiaoQianJson: BiaoQianJson
		})
    }

    render(){
        return(
            <div className={this.state.bgFlag?'Xgundong cart':'cart'}>
                <div className={this.state.Screen?'search-header search-header red-bg':'search-header search-header'}>
	                <div className={'search-wrap'} onClick={this.searchClick.bind(this,{display:"block"})}>
                        <div className={'search-icon'}></div>
                        <div className={'search-text'}>搜索</div>
                    </div>
                    <div className={'login-wrap'}>
                        <div className={'my'} onClick={this.pushPage.bind(this)}>
                        	<span className={'mesSpan hide'}>10</span>
                        </div>
                    </div>
                </div>
                <div ref='swiper-container' className={"swiper-container"}>
					<div className="swiper-wrapper">
					  	{
	            			this.state.aSwitch.map((item,index) => {
	            				return (
	            					<div key={index} className="swiper-slide" onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item.Obj_ID)}>
	            						<img src={item.Shp_Url?item.Shp_Url:require('../../../assets/images/home/index/banner_5.jpg')} alt={item.Shp_Site} />
	            					</div>
	            				)
	            			})
	                	}
					</div>
					<div ref='swiper-pagination' className={'swiper-pagination'}></div>
				</div>
				<div className={'quick-nav'}>
					<ul className={'item'} onClick={this.LeftIcon.bind(this, '/AllCourse')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/video/b1.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>全部课程</li>
                    </ul>
                    <ul className={'item'} onClick={this.LeftIcon.bind(this, '/NewCourse')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/video/b2.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>最新课程</li>
                    </ul>
                    <ul className={'item'} onClick={this.LeftIcon.bind(this, '/FreeCourse')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/video/b3.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>免费课程</li>
                    </ul>
                    <ul className={'item'} onClick={this.LeftIcon.bind(this, '/NavCourse')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/video/b4.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>课程分类</li>
                    </ul>
                </div>
                {
                	this.state.BiaoQianJson2?
                	this.state.BiaoQianJson2.map((item,index) => {
                		if(item.outlines){
                			return (
	                			<div className={'found'} key={index}>
				                	<div className={'found-title2'} style={{'marginBottom': '0'}}>
				                		{item.tagName}
				                		<span className={'found-title2-sp'}>全部</span>
				                	</div>
				                	<div className={'found-title-wrap'}>
				                		<div className={'found-classroom2 course'}>
				                		{
				                			item.outlines.map((item2,index2) => {
				                				return(
				                					<div className={'found-classroom-div'} onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item2.merchandiseId)} key={index2}>
							                			<div className={'found-classroom-img'}>
							                            	<img src={item2.Ol_Logo != ""?item2.Ol_Logo:require('../../../assets/images/video/pic_cover.png')} />
							                            	<span>课程</span>
							                            </div>
							                            <div className={'bookNmae'}>
							                            	<div className={'bookNmae-title'}>{item2.Ol_Name}</div>
							                            	<div>导师：{item2.TeacherName}</div>
							                            </div>
						                			</div>
				                				)
				                				
				                			})
				                		}
				                        </div>
				                	</div>
				                </div>
	                		)
                		}
                	})
                	:<div className={"null"}>暂无课程内容!</div>
                }
                <div className={this.state.bgFlag?'bg':'hide'}>
                	<div onClick={this.alertBtn.bind(this, '0')} style={{width:'40vw',height: '100vh',float: 'left'}}></div>
                	<div className={'box'}>
                		<div className={'bgTitle'}>课程分类</div>
                		<div className={'bgCont'}>
                		{
                			this.state.BiaoQianJson?
                			this.state.BiaoQianJson.map((item,index) => {
                				return(
                					<div className={item.checked?'active':''} key={index} onClick={this.tagNameClick.bind(this, index)}>{item.tagName}</div>
                				)
                			})
                			:''
                		}
                		
                		</div>
                		<div className={'bgfoot'}>
                			<div onClick={this.alertBtn.bind(this, '1')}>确定</div>
                			<div onClick={this.alertBtn.bind(this, '2')}>重置</div>
                		</div>
                	</div>
                </div>
                {
//              <div className={'found'}>
//              	<div className={'found-title2'} style={{'marginBottom': '0'}}>
//              		猪猪家族的饲养法则四课
//              	</div>
//              	<div className={'found-title-wrap'}>
//              		<div className={'found-classroom2 course'}>
//              			<div>
//	                			<div className={'found-classroom-img'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            </div>
//	                            <div className={'bookNmae'}>
//	                            	<div className={'bookNmae-title'}>小猪毛的美食宝典</div>
//	                            	<div>最爱章鱼小丸子</div>
//	                            	<div>朱绒绒·美食品尝师</div>
//	                            	<div>14885人学习</div>
//	                            	<div className={'bookNmae-last'}>免费</div>
//	                            </div>
//              			</div>
//              			<div>
//	                			<div className={'found-classroom-img'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            </div>
//	                            <div className={'bookNmae'}>
//	                            	<div className={'bookNmae-title'}>小猪毛的美食宝典</div>
//	                            	<div>最爱章鱼小丸子</div>
//	                            	<div>朱绒绒·美食品尝师</div>
//	                            	<div>14885人学习</div>
//	                            	<div className={'bookNmae-last'}>免费</div>
//	                            </div>
//              			</div>
//              			<div>
//	                			<div className={'found-classroom-img'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            </div>
//	                            <div className={'bookNmae'}>
//	                            	<div className={'bookNmae-title'}>小猪毛的美食宝典</div>
//	                            	<div>最爱章鱼小丸子</div>
//	                            	<div>朱绒绒·美食品尝师</div>
//	                            	<div>14885人学习</div>
//	                            	<div className={'bookNmae-last'}>免费</div>
//	                            </div>
//              			</div>
//              			<div>
//	                			<div className={'found-classroom-img'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            </div>
//	                            <div className={'bookNmae'}>
//	                            	<div className={'bookNmae-title'}>小猪毛的美食宝典</div>
//	                            	<div>最爱章鱼小丸子</div>
//	                            	<div>朱绒绒·美食品尝师</div>
//	                            	<div>14885人学习</div>
//	                            	<div className={'bookNmae-last'}>免费</div>
//	                            </div>
//              			</div>
//                      </div>
//              	</div>
//              </div>
                }
                
                <div style={{height: 1.5+'rem'}}></div>
                <SearchComponent searchStyle={this.searchStyle} display={this.searchClick.bind(this)}></SearchComponent>
            </div>
        );
    }
}